import { FC, useRef } from 'react';
import { EmployeeType } from '../../../../../../store/api/employees-api';
import s from './employee-profile-download.module.css';
import { useLang } from '../../../../../../hooks/use-lang';
import { Button } from '../../../../../../components/button/button';
import { Card } from '../../../../../../components/card/card';
import { QrCode } from '../../../../../../components/qr-code/qr-code';
import { Select } from '../../../../../../components/select/select';
import { IdValue } from '../../../../../../types/props';
import { toPng } from 'html-to-image';
import { jsPDF } from 'jspdf';
import { Link } from 'react-router-dom';

interface Props {
  employee: Partial<EmployeeType>;
  qr?: IdValue;
  setQr: (qr: IdValue) => void;
  employeeUrl?: string;
}

export const EmployeeProfileDownload: FC<Props> = (props) => {
  const { employee, qr, setQr, employeeUrl } = props;
  const { t, getLocale } = useLang();

  const isProfileExist = !!getLocale(employee.profile?.display_title);

  const qrRef = useRef<HTMLDivElement>(null);

  const downloadPng = async () => {
    if (qrRef.current) {
      const dataUrl = await toPng(qrRef.current);
      const link = document.createElement('a');
      link.href = dataUrl;
      link.download = 'qr-code.png';
      link.click();
    }
  };

  const downloadPdf = async () => {
    if (qrRef.current) {
      const dataUrl = await toPng(qrRef.current);
      const pdf = new jsPDF();
      const imgProps = pdf.getImageProperties(dataUrl);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(dataUrl, 'PNG', 0, 0, pdfWidth, pdfHeight);
      pdf.save('qr-code.pdf');
    }
  };

  return (
    <Card className={s.feature} title={`2. ${t('QR')}`}>
      {isProfileExist ? (
        <div className={s.wrapper}>
          <Select
            options={
              employee?.profile?.available_qrs?.map((item) => ({
                id: item.id,
                value: getLocale(item.value),
              })) || []
            }
            value={qr}
            onSelect={setQr}
          />
          <QrCode className={s.qr} data={employeeUrl} ref={qrRef} />
          {employeeUrl && <Link to={employeeUrl} target="_blank" className={s.link}>{t('Просмотр профиля')}</Link>}
          <Button variant="secondary" fullWidth size="lg" onClick={downloadPng}>
            {t('Скачать PNG')}
          </Button>
          <Button variant="secondary" fullWidth size="lg" onClick={downloadPdf}>
            {t('Скачать PDF')}
          </Button>
        </div>
      ) : (
        <div className={s.empty}>{t('Сначала создайте профиль')} </div>
      )}
    </Card>
  );
};
